import { UserContext } from "context";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const useUserContext = () => useProviderInitializedContext(UserContext);
